<template>
	<svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.989 31.985">
		<g id="c">
			<g>
				<path
					:fill="color"
					d="M11.205,10.164c.619-3.116,2.796-6.507,4.621-9.173,1.327,2.64,4.851,8.753,4.851,8.753,0,0,7.299,1.355,10.302,2.164-1.849,2.722-7.38,8.224-7.38,8.224l2.907,10.343-10.527-4.797s-3.182,1.755-6.339,3.203c-1.881,.863-3.15,1.786-4.821,2.111-.175-1.705,.379-3.696,1.071-5.977,.274-.904,1.797-4.282,1.797-4.282,0,0-3.315-3.929-4.224-5.065-.902-1.128-1.935-2.236-2.484-3.538,2.555-1.205,10.226-1.964,10.226-1.964Z"
				/>
				<path
					d="M12.169,10.43c.717-3.295,2.646-6.187,4.52-8.934h-1.727c.986,1.948,2.066,3.849,3.14,5.75,.431,.764,.865,1.526,1.301,2.287,.242,.422,.432,.901,.889,1.125,.341,.166,.799,.178,1.166,.248,.945,.18,1.889,.364,2.832,.552,2.148,.428,4.305,.853,6.423,1.414l-.598-1.469c-2.031,2.932-4.702,5.511-7.223,8.022-.251,.25-.353,.63-.257,.973,.969,3.448,1.938,6.895,2.907,10.343l1.469-1.129c-3.043-1.386-6.086-2.773-9.129-4.159-.444-.202-.885-.442-1.342-.612-.781-.29-1.247,.077-1.929,.441-1.521,.813-3.059,1.596-4.617,2.335-1.767,.838-3.52,1.978-5.441,2.411l1.266,.964c-.248-3.368,1.379-6.751,2.731-9.755,.199-.443,.157-.841-.156-1.212-.87-1.032-1.739-2.065-2.603-3.101-1.39-1.665-3.032-3.325-3.948-5.3l-.359,1.368c1.785-.802,3.914-1.041,5.832-1.333,1.292-.197,2.589-.365,3.889-.495,1.269-.127,1.282-2.128,0-2-3.525,.352-7.469,.635-10.73,2.101-.524,.235-.566,.923-.359,1.368,.951,2.048,2.641,3.761,4.079,5.486,.925,1.11,1.854,2.215,2.786,3.319l-.156-1.212c-1.495,3.319-3.279,7.037-3.004,10.764,.049,.665,.598,1.115,1.266,.964,2.365-.532,4.6-1.965,6.765-3.019,1.563-.761,3.111-1.557,4.634-2.395h-1.009c3.509,1.599,7.018,3.198,10.527,4.797,.757,.345,1.723-.226,1.469-1.129-.969-3.448-1.938-6.895-2.907-10.343l-.257,.973c2.647-2.636,5.404-5.348,7.536-8.426,.37-.535-.011-1.314-.598-1.469-3.387-.898-6.858-1.524-10.302-2.164l.598,.46c-1.664-2.888-3.345-5.779-4.851-8.753-.362-.716-1.333-.578-1.727,0-1.968,2.886-3.968,5.951-4.722,9.412-.273,1.255,1.654,1.791,1.929,.532Z"
					style="fill: #231815"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'star',
	props: {
		color: {
			type: String,
			default: 'transparent',
		},
	},
};
</script>
